import { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

export const surfacesCustomizations: Components<Theme> = {
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        // Remove only horizontal margins and padding on mobile (xs and sm)
        [theme.breakpoints.down('md')]: {
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: 0,
          paddingRight: 0,
          borderRadius: 0, // Remove border rounding on mobile
          '& .MuiCardContent-root': {
            paddingLeft: 0,
            paddingRight: 0,
            // Keep top and bottom padding
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            '&:last-child': {
              paddingBottom: theme.spacing(1),
            },
          },
        },
        // Keep normal spacing on desktop
        [theme.breakpoints.up('md')]: {
          '& .MuiCardContent-root': {
            padding: theme.spacing(2),
            '&:last-child': {
              paddingBottom: theme.spacing(2),
            },
          },
        },
      }),
    },
  },
  MuiGrid2: {
    styleOverrides: {
      root: ({ theme }) => ({
        // Set border color to theme paper color
        borderColor: theme.palette.background.paper,
        // Remove only horizontal margins and padding on mobile (xs and sm)
        [theme.breakpoints.down('md')]: {
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: 0,
          paddingRight: 0,
          borderRadius: '0 !important', // Remove border rounding on mobile
          '&.MuiGrid2-container': {
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0,
            borderRadius: '0 !important', // Remove border rounding on mobile
            '& > .MuiGrid2-item': {
              paddingLeft: 0,
              paddingRight: 0,
              borderRadius: '0 !important', // Remove border rounding on mobile
              // Keep top and bottom padding/margins
              paddingTop: 'inherit',
              paddingBottom: 'inherit',
              marginTop: 'inherit',
              marginBottom: 'inherit',
            },
          },
          // Target all child elements that might have border radius
          '& *': {
            borderRadius: '0 !important',
          },
          // Specifically target common elements that might have border radius
          '& .MuiCard-root': {
            borderRadius: '0 !important',
          },
          '& .MuiPaper-root': {
            borderRadius: '0 !important',
          },
          '& .MuiBox-root': {
            borderRadius: '0 !important',
          },
        },
        // Keep normal spacing on desktop
        [theme.breakpoints.up('md')]: {
          // Use default MUI spacing
        },
      }),
    },
  },
};
